import { useSelector } from "react-redux";
import { getResponseDetailsForCompareAsArray } from "../../store/quotes";
import { useEffect } from "react";
import { getBrokerInformation } from "../../store/broker";
import translations from "../../utils/translations";

const SelectCovers = ({
  location,
  building,
  coversOfCoverType,
  conversToBeRemovedByImportance,
  getCoverValue,
  selectedCovers,
  handleChecked,
}) => {
  const insurers = useSelector(getResponseDetailsForCompareAsArray);
  let { information } = useSelector(getBrokerInformation);
  const languagePreference = information.languagepreference;
  console.log("hey we got lang", languagePreference);
  const isCoverSelected = (coverId) => {
    if (Array.isArray(selectedCovers)) {
      return selectedCovers.includes(coverId);
    } else if (selectedCovers && typeof selectedCovers === "object") {
      if (location && building) {
        return selectedCovers[coverId] === true;
      } else if (location) {
        return selectedCovers[coverId] === true;
      } else {
        return selectedCovers[coverId] === true;
      }
    }
    return false;
  };

  useEffect(() => {
    console.log("find the value coversOfCoverType", coversOfCoverType);
    console.log("find the value insurers", insurers);
    console.log("find the value location", location);
  }, []);
  return (
    <>
      <div
        style={{
          height: "800px",
          paddingRight: "0vmin",
          paddingLeft: "0vmin",
        }}
      >
        <div
          className="card"
          style={{
            height: "800px",
          }}
        >
          <div
            className="card-body "
            style={{
              height: "auto",
              overflowY: "auto",
              overflowX: "hidden",
              display: "block",
            }}
          >
            <table className="table table-striped">
              <thead className="col">
                <tr>
                  <th scope="col-md-6">
                    {translations[languagePreference].coverage}{" "}
                  </th>
                  {insurers.map((insurer) => (
                    <th scope="col-md-6">{insurer.insurercode}</th>
                  ))}
                  <th scope="col-md-6">Action</th>
                </tr>
              </thead>
              <tbody>
                {coversOfCoverType &&
                  coversOfCoverType
                    .filter(
                      (it) => !conversToBeRemovedByImportance.includes(it.id)
                    )
                    .map((cover, i) => {
                      return (
                        <tr key={cover.id}>
                          <td>
                            <label
                              style={{
                                cursor: "pointer",
                                fontWeight:
                                  cover.parentid === null ? "bold" : "normal",
                                color:
                                  cover.parentid === null
                                    ? "your-desired-color"
                                    : "inherit",
                              }}
                              htmlFor={`id-${cover.id}`}
                            >
                              {cover.parentid !== null ? `\u00A0 - ` : null}
                              {cover?.name && cover?.name[languagePreference] ? (
                                 <span style={{ fontWeight: "bold" }}>
                                    {cover?.name[languagePreference]}
                                  </span>
                                ) : null}
                              {/* {cover.parentid === null ? (
                                <span style={{ fontWeight: "bold" }}>
                                 
                                  {languagePreference === "fr"
                                    ? cover?.frname || cover?.name
                                    : cover?.name}
                                </span>
                              ) : languagePreference === "fr" ? (
                                cover?.frname || cover?.name
                              ) : (
                                cover?.name
                              )} */}
                            </label>
                          </td>

                          {insurers.map((insurer) => (
                            <td>
                              {getCoverValue(
                                { insurer, cover },
                                building
                                  ? `${location?.id}_building_${building}`
                                  : location?.id
                              )}
                            </td>
                          ))}
                          <td>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={cover.id}
                                id={`id-${cover.id}`}
                                onChange={(event) => {
                                  handleChecked(
                                    event.target.checked,
                                    cover.id,
                                    location,
                                    building
                                  );
                                }}
                                checked={isCoverSelected(cover?.id)}
                                // id="flexCheckDefault"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectCovers;
